import { call, put } from 'redux-saga/effects';

import { apiGeneral, queryBuilder, notify } from 'services';
import { requestErrorHandler } from 'utils';
import { ListDatatableFilterConfigsActions } from 'store/ducks/settings/configs/list-datatable-filter-configs';

export function* listDatatableFilterConfigsRequest() {
  try {
    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/datatable-filter-configs`
    );

    const { filterConfigs } = responseBody;

    yield put(ListDatatableFilterConfigsActions.success(filterConfigs));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(ListDatatableFilterConfigsActions.failure(errorMessage));
  }
}
